import { unwrap, unwrapVoid } from '../http.js';
export function createRemindersApi(client) {
    return {
        async get() {
            return unwrap(await client.GET('/v1/me/reminders'));
        },
        async put(body) {
            return unwrap(await client.PUT('/v1/me/reminders', { body }));
        },
        async configuration() {
            return unwrap(await client.GET('/v1/push/vapid-public-key'));
        },
        async subscribe(body) {
            return unwrap(await client.POST('/v1/me/push-subscriptions', { body }));
        },
        async unsubscribe(id) {
            unwrapVoid(await client.DELETE('/v1/me/push-subscriptions/{id}', { params: { path: { id } } }));
        },
        async test() {
            return unwrap(await client.POST('/v1/me/push-subscriptions/test'));
        },
    };
}
//# sourceMappingURL=reminders.js.map